import { useTranslation } from "react-i18next"
// icons
import { FaRegUser } from "react-icons/fa"
import { HiOutlineDevicePhoneMobile } from "react-icons/hi2"
import { HiOutlineMail } from "react-icons/hi"
import { BiStats } from "react-icons/bi"
// herlpers
import size from 'lodash/size'

const getString = (val) => {
  if (size(val) > 0) return val
  return '-'
}

interface UserInterface {
  identity_first_name: string
  identity_email: string
  identity_phone: string
  identity_point_count: string
}

interface UserCardInterface {
  user: UserInterface
  title: string
}

const UserCard: React.FC<UserCardInterface> = ({ user, title }) => {
  const { t } = useTranslation()

  return (
    <div className="account">
      <h3>{title}</h3>
      <div className="userAttribute">
        <span><FaRegUser color="#0061df" /> {t('USER_NAME')}</span>
        {getString(user?.identity_first_name)}
      </div>
      <div className="userAttribute">
        <span><HiOutlineMail color="#0061df" /> {t("USER_EMAIL")}</span>
        {getString(user?.identity_email)}
      </div>
      <div className="userAttribute">
        <span><HiOutlineDevicePhoneMobile color="#0061df" /> {t("USER_PHONE")}</span>
        {getString(user?.identity_phone)}
      </div>
      <div className="userAttribute">
        <span><BiStats color="#0061df" /> {t("USER_AVAILABLE_POINTS")}</span>
        {getString(user?.identity_point_count)}
      </div>
    </div>
  )
}

export default UserCard